import { render, staticRenderFns } from "./OrgnzDetail.vue?vue&type=template&id=0ca8cc2f&"
import script from "./OrgnzDetail.vue?vue&type=script&lang=js&"
export * from "./OrgnzDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports